import { LinkAnchor } from '@Components/Common/CommonMethods'
import DialogComponent from '@Components/Common/DialogComponent'
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react'


function useOutsideAlerter(ref, callBack) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callBack();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {

            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}


const DialogCustomerinfo = ({ snpKitPopup, setSnpKitPopup, handleAddKitProduct }) => {

    const wrapperRef = useRef(null);
    const router = useRouter();

    const ARRAY = ["rs693", "rs1244414", "rs4680", "rs1205", "rs1799998", "rs1051740", "rs9939609", "rs1121980", "rs602662", "rs1695", "rs1800795", "rs1801133",
        "rs1801131", "rs1801394", "rs1800566", "rs662", "rs4880", "rs1800629", "rs2228570", "rs7975232", "rs1544410", "rs731236"]

    // const ARRAY2 = ["rs7975232", "rs1544410", "rs731236"];

    function handleClose() {
        setSnpKitPopup(false)
    }


    useOutsideAlerter(wrapperRef, () => {
        setSnpKitPopup(false)
        handleClose();
    });
    const HoverData = {
        "rs9939609": "FTO: Healthy weight management and hunger response",
        "rs1800566": "NQO1: Energy and heart health",
        "rs1801394": "MTRR: Heart health and homocysteine levels",
        "rs1244414": "ATP5C1: Mitochondrial function (cellular energy)",
        "rs1799998": "CYP11B2: Healthy blood pressure and adrenal support",
        "rs1801133": "MTHFR: Methylation; detoxification; mood; fertility; inflammation",
        "rs1121980": "FTO: Healthy weight management and hunger response",
        "rs1205": "CRP: Healthy inflammatory response",
        "rs1800795": "IL-6: Healthy immune and inflammatory responses",
        "rs662": "PON1: Support in detoxifying 'bad' cholesterol",
        "rs1051740": "EPHX1: Detoxification of chemicals and pesticides; liver health",
        "rs2228570": "VDR-Fok1: Vitamin D absorption/ utilization, bone health, mood/brain function, immunity",
        "rs1800629": "TNF - α: Healthy inflammatory response",
        "rs1801131": "MTHFR: Methylation; detoxification; mood; fertility; inflammation",
        "rs1695": "GSTP1: Detoxification and cellular protection",
        "rs693": "APOB: Healthy lipids; healthy heart, nerve and cell function, communication, and repair",
        "rs602662": "FUT2: B12 vitamin conversion, immune function, microbiome, and heart health",
        "rs4880": "SOD2: Detoxification and cellular protection",
        "rs4680": "COMT: Neurotransmitter recycling and stress hormone breakdown",
        "rs7975232": "VDR-Apa1: Healthy immune response, healthy kidney function, healthy mucosal membranes, healthy thyroid function, healthy body mass index, healthy bone density",
        "rs1544410": "VDR-Bsm1: Bone integrity, healthy skin response to UV damage/oxidative stress, mucosal membrane support",
        "rs731236": "VDR-Taq1: Healthy heart, healthy immune response, healthy sugar/ insulin metabolism, healthy thyroid function, healthy brain, healthy gut, healthy BMI, healthy oral microbiome, healthy skin response to UV damage/oxidative stress, healthy nerve function, healthy kidney function",
    }

    return (
        <div>
            <DialogComponent opend={snpKitPopup} handleClose={() => setSnpKitPopup(false)} classFor="kitPopup-content">
                <div className='code-complex' ref={wrapperRef}>
                    <p className='personalized nutritional kit'>SNiP's DNA-personalized nutrition is based on the following nineteen
                        genetic SNPs (as indicated by their specific "rs" numbers below).</p>
                    <div className="personlised-nutrition-content">
                        <p className='personalized nutritional kit'>Please compare the rs numbers below to your raw data or raw data search tool:</p>

                        <div className='listing'>
                            {ARRAY?.map((row) => {
                                return (
                                    <>
                                        <p className='personalized nutritional listing_class'>
                                            <span className='listing-txt'>
                                                {row}
                                            </span>
                                            <span className='manual-tooltip'> {HoverData[row]}</span>
                                        </p>
                                    </>
                                )
                            })}
                        </div>
                    </div>
                    {/* <p className='personalized nutritional kit'>
                        Additional SNPs: Advancements are coming to CODE Complex™ in 2024.
                        The following SNPs will further personalize your product.
                        </p>*/}
                    {/* <div className='listing'>
                        {ARRAY2?.map((row) => {
                            return (
                                <>
                                    <p className='personalized nutritional listing_class'>
                                        <span className='listing-txt'>
                                            {row}
                                        </span>
                                        <span className='manual-tooltip'> {HoverData[row]}</span>
                                    </p>
                                </>
                            )
                        })}
                    </div>*/}
                    <p className='personalized nutritional kit'>If you are missing one or more rs numbers, we can still formulate for you
                        (your CODE Complex™ will support the variants for which you have provided data).
                        However, if you want your personalized supplement to cover any/all genetic variants for which we formulate, you can purchase a SNIP DNA Test Kit now.</p>
                    <div className='dna_info'>
                        <button className='choose-complex' onClick={handleAddKitProduct}>Purchase my SNiP DNA Test Kit here</button>
                    </div>
                    <div className='dna_info'>
                        {/* <button className='choose-complex' onClick={() => router?.push("/dna_info")}>I'm all set! Return to page</button> */}
                        <button className='choose-complex' onClick={() => setSnpKitPopup(false)}>I'm all set! Return to page</button>
                    </div>
                    <div className="dna_info-btn">
                        <p className='personalized nutritional' style={{ fontSize: 18 }}>Questions? We’re here to help!</p>
                        <p className='personalized nutritional' style={{ fontSize: 18 }}>  Email us at <LinkAnchor href="mailto:support@snipnutrition.com">support@snipnutrition.com</LinkAnchor> </p>
                    </div>

                </div>

            </DialogComponent>
        </div>
    )
}

export default DialogCustomerinfo;